import React from 'react';
import PropTypes from 'prop-types';

// IDPUT
import TextFieldGroup from '../../../../../components/common/textFieldGroup/TextFieldGroup';

// VALIDATIONS
import isEmptyVAL from '../../../../../validations/checks/isEmptyVAL';

// UTILITIES
import { outputMasterUTL } from '../../../../../utils/outputMasterUTL';
import { transUTL } from '../../../../../utils/transUTL';

const IdentityDetailsMexico = ({
  formState,
  selectedDataSources,
  handleOnChange,
  handleOnBlur,
  handleEnterKeyTrigger,
}) => {
  const { curp, rfc, errors } = formState;

  const inputElements = [
    {
      belongsTo: ['Mexico National ID', 'Mexico Tax Registration'],
      element: (
        <TextFieldGroup
          key="curp"
          id="curp"
          type="text"
          name="curp"
          dataName="curpMX"
          labelClass="form-group__label"
          label={transUTL('translateFormOverview.inputLabels.curp')}
          value={curp}
          placeholder={transUTL('translatePlaceholder.inputMX.curp')}
          placeholderTrigger={isEmptyVAL(curp) ? 'input-empty' : ''}
          error={errors.curp}
          errorTrigger={errors.curp ? 'input-error' : ''}
          handleOnChange={handleOnChange}
          handleOnBlur={handleOnBlur}
          handleEnterKeyTrigger={handleEnterKeyTrigger}
        />
      ),
    },
    {
      belongsTo: ['Mexico National ID', 'Mexico Tax Registration'],
      element: (
        <TextFieldGroup
          key="rfc"
          id="rfc"
          type="text"
          name="rfc"
          dataName="rfcMX"
          labelClass="form-group__label"
          label={transUTL('translateFormOverview.inputLabels.rfc')}
          value={rfc}
          placeholder={transUTL('translatePlaceholder.inputMX.rfc')}
          placeholderTrigger={isEmptyVAL(rfc) ? 'input-empty' : ''}
          error={errors.rfc}
          errorTrigger={errors.rfc ? 'input-error' : ''}
          handleOnChange={handleOnChange}
          handleOnBlur={handleOnBlur}
          handleEnterKeyTrigger={handleEnterKeyTrigger}
        />
      ),
    },
  ];

  return (
    <div className="form-overview__form-inputs">
      {outputMasterUTL(selectedDataSources, inputElements)}
      <span />
    </div>
  );
};

IdentityDetailsMexico.propTypes = {
  formState: PropTypes.object.isRequired,
  selectedDataSources: PropTypes.array.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleOnBlur: PropTypes.func.isRequired,
  handleEnterKeyTrigger: PropTypes.func.isRequired,
};

export default IdentityDetailsMexico;
